import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[communicationOtherDetailDirective]',
})
export class CommunicationOtherDetailDirective {
  constructor(public viewContainerRef: ViewContainerRef) { }
}